// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadToDta200ResponseFilesInner } from './upload-to-dta200-response-files-inner';
import {
    UploadToDta200ResponseFilesInnerFromJSON,
    UploadToDta200ResponseFilesInnerFromJSONTyped,
    UploadToDta200ResponseFilesInnerToJSON,
    UploadToDta200ResponseFilesInnerToJSONTyped,
} from './upload-to-dta200-response-files-inner';

/**
 * 
 * @export
 * @interface UploadToDta200Response
 */
export interface UploadToDta200Response {
    /**
     * 
     * @type {Array<UploadToDta200ResponseFilesInner>}
     * @memberof UploadToDta200Response
     */
    files?: Array<UploadToDta200ResponseFilesInner>;
}

/**
 * Check if a given object implements the UploadToDta200Response interface.
 */
export function instanceOfUploadToDta200Response(value: object): value is UploadToDta200Response {
    return true;
}

export function UploadToDta200ResponseFromJSON(json: any): UploadToDta200Response {
    return UploadToDta200ResponseFromJSONTyped(json, false);
}

export function UploadToDta200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadToDta200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadToDta200ResponseFilesInnerFromJSON)),
    };
}

export function UploadToDta200ResponseToJSON(json: any): UploadToDta200Response {
    return UploadToDta200ResponseToJSONTyped(json, false);
}

export function UploadToDta200ResponseToJSONTyped(value?: UploadToDta200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadToDta200ResponseFilesInnerToJSON)),
    };
}
